import { DocumentNode } from 'graphql';
import { SelectOption } from 'global';
import { ProductDetailsMappedData, ProposalsViewTypes } from '../types';
import { ProposalSaleType, AftermarketProductCategory } from '@trnsact/trnsact-shared-types';
import {
  GET_PROPOSAL_METRICS,
  GET_PROPOSALS_FOR_HUB_TABLE,
  GET_PROPOSALS_FOR_HUB_TABLE_BY_ACCOUNT,
  GET_PROPOSALS_FOR_HUB_TABLE_PAGINATED,
  GET_PROPOSALS_FOR_HUB_TABLE_BY_ACCOUNT_PAGINATED,
} from '../api';

export const hubTableApiQueryByType: Record<ProposalsViewTypes, DocumentNode> = {
  [ProposalsViewTypes.All]: GET_PROPOSALS_FOR_HUB_TABLE_BY_ACCOUNT_PAGINATED,
  [ProposalsViewTypes.My]: GET_PROPOSALS_FOR_HUB_TABLE_PAGINATED,
  [ProposalsViewTypes.Dashboard]: GET_PROPOSAL_METRICS,
};

export const hubTableApiQueryByTypeNonPaginated: Record<ProposalsViewTypes, DocumentNode> = {
  [ProposalsViewTypes.All]: GET_PROPOSALS_FOR_HUB_TABLE_BY_ACCOUNT,
  [ProposalsViewTypes.My]: GET_PROPOSALS_FOR_HUB_TABLE,
  [ProposalsViewTypes.Dashboard]: GET_PROPOSAL_METRICS,
};

export const proposalSaleTypeToViewText: Record<ProposalSaleType, string> = {
  [ProposalSaleType.FinanceOnly]: 'Finance',
  [ProposalSaleType.CashWithAftermarketMenu]: 'Cash',
  [ProposalSaleType.FinanceWithAftermarketMenu]: 'Finance',
} as const;

export const proposalSaleTypeToFilterLAbel: Record<ProposalSaleType, string> = {
  [ProposalSaleType.FinanceOnly]: 'Finance Only',
  [ProposalSaleType.CashWithAftermarketMenu]: 'Cash',
  [ProposalSaleType.FinanceWithAftermarketMenu]: 'Finance',
} as const;

export const productsTypesOptions: Readonly<SelectOption<AftermarketProductCategory>[]> = [
  { label: 'GAP', value: AftermarketProductCategory.Gap },
  { label: 'Insurance', value: AftermarketProductCategory.Insurance },
  { label: 'Roadside', value: AftermarketProductCategory.Roadside },
  { label: 'ServiceContract', value: AftermarketProductCategory.ServiceContract },
];

export const productsDetailsInitialValue: ProductDetailsMappedData = {
  tableData: [],
  totals: { cost: 0, markup: 0, retailCost: 0 },
};

export const dealTypeToLabel: Record<string, string> = {
  RENEWAL: 'Renewal',
  WEB_LEAD: 'Direct Lead',
  MISSED_SALE: 'Missed Sale',
};

export const proposalColorStatusByTitle: Record<string, string> = {
  Accepted: '#D3F2BD',
  Draft: '#FFE897',
  'Proposal Sent': '#C8E3F8',
  Funded: '#A8F6D9',
  Declined: '#FBA18D',
  'Viewed by customer': '#D9D8F8',
  Contract: '#ddc96a',
  'Awaiting Dealer Approval': '#e9d8f8',
};
